/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusPrivacyPolicyListItemDto } from '../../models/lexplus-privacy-policy-list-item-dto';

export interface PrivacyPolicyControllerFindAllV1$Params {
}

export function privacyPolicyControllerFindAllV1(http: HttpClient, rootUrl: string, params?: PrivacyPolicyControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusPrivacyPolicyListItemDto>>> {
  const rb = new RequestBuilder(rootUrl, privacyPolicyControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusPrivacyPolicyListItemDto>>;
    })
  );
}

privacyPolicyControllerFindAllV1.PATH = '/v1/privacy-policies';
